export const createInvitationFormName = id => ( "invitation" + id );
export const createDeleteTeamForm = id => ( "invitation" + id );